<i18n>
{
    "de": {
        "power": "Leistung",
        "constantCurrent": "Konstant&shy;strom",
        "constantVoltage": "Konstant&shy;spannung",
        "dimmable": "Dimmbar",
        "lamps": "Leuchten / Driver"
    },
    "en": {
        "power": "Power",
        "constantCurrent": "Constant Current",
        "constantVoltage": "Constant Voltage",
        "dimmable": "Dimmable",
        "lamps": "Luminaires / Driver"
    }
}
</i18n>

<template>
  <div class="mt-3">
    <b style="font-size: 15px" v-if="version !== '-'">
      {{ version.replace(".", ",") }}
      <!-- {{
        ["CLIPPO EP", "CLIPPO S EP", "PHOENIX"].includes(productTitel)
          ? " - " + productTitel
          : ""
      }} -->
    </b>
    <div class="c-drivers__grid">
      <div class="c-drivers__tableheader">Code</div>
      <div class="c-drivers__tableheader u-text-right d-none d-md-block">
        {{ $t("power") }}
      </div>
      <div
        class="c-drivers__tableheader u-text-right"
        v-html="
          drivers[0].constant_voltage !== 1
            ? $t('constantCurrent')
            : $t('constantVoltage')
        "
      >
        <!-- {{
                    drivers[0].constant_voltage !== "1"
                        ? $t("constantCurrent")
                        : $t("constantVoltage")
                }} -->
      </div>
      <div class="c-drivers__tableheader u-text-center">
        {{ $t("dimmable") }}
      </div>
      <div class="c-drivers__tableheader u-text-right d-none d-md-block">
        LxWxH (mm)
      </div>
      <div class="c-drivers__tableheader u-text-center" v-html="$t('lamps')">
        <!-- {{ $t("lamps") }} -->
      </div>
      <div class="c-line"></div>
      <template v-for="(driver, index) in drivers" class="row py-2">
        <div
          :key="'drivercode-' + index"
          v-html="driver.code"
          class="u-whitespace-nowrap"
        ></div>
        <div
          :key="'driverpower-' + index"
          class="u-text-right d-none d-md-block"
        >
          <div
            v-for="(powerEntry, powerIndex) of driver.power"
            :key="powerIndex"
          >
            {{ powerEntry ? powerEntry.replaceAll(".", ",") : powerEntry }}
            W
          </div>
        </div>
        <div :key="'driverconstant-' + index" class="u-text-right">
          <div
            v-for="(constantEntry, constantIndex) of driver.constant"
            :key="constantIndex"
          >
            {{ constantEntry }}
            {{ driver.constant_voltage !== 1 ? "mA" : "Vdc" }}
          </div>
        </div>
        <div :key="'driverdim-' + index" class="u-text-center">
          <span
            v-for="(dimmableEntry, dimmableEntryIndex) of driver.dimmable"
            :key="dimmableEntryIndex"
          >
            {{ dimmableEntry
            }}<template v-if="dimmableEntryIndex < driver.dimmable.length - 1"
              >,
            </template>
          </span>
        </div>
        <div
          :key="'driversize-' + index"
          class="u-text-right d-none d-md-block"
        >
          {{ driver.size.replaceAll(" ", "") }}
        </div>
        <div
          :key="'driverlights-' + index"
          v-html="driver.light ? driver.light : ''"
          class="u-text-center"
        ></div>
        <!-- <div
          :key="'driverlights-' + index"
          v-html="
            driver.light ? driver.light.replace('<sup>2</sup>', '**') : ''
          "
          class="u-text-center"
        ></div> -->
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    version: {
      required: true,
      type: String,
    },
    drivers: {
      required: true,
      type: Array,
    },
    productTitel: {
      required: true,
      type: String,
    },
  },
};
</script>

<style></style>
